import * as React from "react";
import Alert from "@mui/material/Alert";
import AlertTitle from "@mui/material/AlertTitle";
import Button from "@mui/material/Button";

export interface BannerAction {
	label: string;
	onClick: () => void;
}

export interface BannerProps {
	severity: "info" | "warning" | "error" | "success";
	title?: string;
	description?: React.ReactNode;
	action?: BannerAction;
	onClose?: () => void;
}

export function Banner({
	severity,
	title,
	description,
	action,
	onClose,
}: BannerProps): React.JSX.Element {
	return (
		<Alert
			severity={severity}
			onClose={onClose}
			action={
				action ? (
					<Button
						color="inherit"
						size="small"
						onClick={action.onClick}>
						{action.label}
					</Button>
				) : undefined
			}
			sx={{ borderRadius: 0 }}>
			{title && <AlertTitle sx={{ mb: 0 }}>{title}</AlertTitle>}
			{description}
		</Alert>
	);
}
